import React from 'react';
import { motion } from 'framer-motion';
import Logo from '../components/Logo';
import BackgroundLayout from '../components/BackgroundLayout';
// import hand3d from '../components/characters/hand3d.png';
import { QRCodeSVG } from 'qrcode.react';
import { useParams, useSearchParams } from 'react-router-dom';

const QrDisplay = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    // Primeros 4 caracteres del CURP: sirve para identificar de quién es
    // este código durante las pruebas.
    const curpRef = searchParams.get('ref');

    const valueToEncode = id || 'https://ejemplo.com';

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Aumenta el tiempo entre la aparición de cada hijo
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 1, // Aumenta la duración de la animación
                ease: "easeInOut", // Suaviza la animación
            },
        },
        exit: {
            opacity: 0,
            y: 20,
            transition: {
                duration: 1, // Aumenta la duración de la animación de salida
                ease: "easeInOut", // Suaviza la animación de salida
            },
        },
    };

    return (
        <BackgroundLayout className="px-8 overflow-hidden pb-24">
            <motion.div
                className="w-full text-left mt-0 lg:w-1/3 lg:mb-10"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Logo />
                <motion.h1 initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }} className='text-5xl font-bold text-[#f8485e] mt-10 uppercase drop-shadow-sm'>Toma captura a este código</motion.h1>
                <motion.h1 variants={itemVariants} className="text-xl text-justify font-bold mt-5 mb-5 text-gray-800 uppercase drop-shadow-sm">Presenta este código al staff de Inspira</motion.h1>
                <motion.div className='flex flex-col mx-auto justify-center place-items-center mt-10'>
                    <QRCodeSVG className='border-8 rounded-2xl border-white shadow-2xl' value={valueToEncode} size={250} />
                    {curpRef && (
                        <p className='mt-4 text-xs font-bold text-gray-500 uppercase tracking-[0.3em]'>
                            Ref: {curpRef}
                        </p>
                    )}
                </motion.div>
            </motion.div>
        </BackgroundLayout>
    );
};

export default QrDisplay;